import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useIsLogged } from "../../../hooks/auth/use-is-logged/use-is-logged";
import { useAbility } from "../../../legacy/hooks/useAbilityRules";
import { getCurrentProfileMigration } from "./profile.api";
import { profileQueryKeys } from "./profile.query-keys";
import type { IUseProfileMigrationQuery } from "./useProfileMigration.query.interface";

export function useProfileMigrationQuery(): IUseProfileMigrationQuery {
  const queryClient = useQueryClient();
  const isLogged = useIsLogged();
  const abilityRules = useAbility();
  const enabled = isLogged && abilityRules.can("readOne", "Account");

  const query = useQuery({
    queryKey: profileQueryKeys.migration(),
    queryFn: getCurrentProfileMigration,
    enabled,
  });

  const revalidate = useCallback(
    function revalidate(): Promise<void> {
      return queryClient.invalidateQueries({
        queryKey: profileQueryKeys.migration(),
      });
    },
    [queryClient]
  );

  return {
    profileMigration: enabled ? query.data : undefined,
    revalidate,
    loading: query.isFetching,
    error: query.error as Error | undefined,
  };
}
